import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(supplierId) {
  return request.send({
    url: `/pmy/sys/sys/supplier?companyId=${supplierId}`,
    method: "delete"
  });
}
// 重置密码
export function resetPassword(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 详情
export function detailInfo(supplierId) {
  return request.send({
    url: `/pmy/sys/sys/supplier?companyId=${supplierId}`,
    method: "get"
  });
}

// 服务商下拉列表（用于下拉选择）
export function getSelectSupplier(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/base/list?belongCompanyId=${data.belongCompanyId}&keyword=${data.keyword}`,
    method: "get"
  });
}

// 查询服务商权限
export function getPermission(companyId) {
  return request.send({
    url: `/pmy/sys/sys/supplier/permission?companyId=${companyId}`,
    method: "get"
  });
}
// 配置服务商权限
export function setPermissions(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/permissions`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
